import { AppConfigContext } from '@App/AppConfigContext';
import { Features } from '@Config/Features';
import { useContext } from 'react';

export function useFeature(featureName: Features) {
  const { features } = useContext(AppConfigContext);
  if (typeof features === 'undefined') {
    return false;
  }
  const currentFeature = features[featureName];
  return currentFeature !== undefined && currentFeature === true;
}
